export const SOCIAL_AUTH_GOOGLE_CLIENT_ID =
  "563502599307-5bpei0i0bj03mqg8u5l975vqsijuj2c7.apps.googleusercontent.com";
export const SOCIAL_AUTH_GOOGLE_SECRET = "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";
// const STATE = "STATE";
export const scope = "https://www.googleapis.com/auth/userinfo.email";

export const API_BASE_URL = "https://cameet.site";

export const OAUTH2_REDIRECT_URI = "http://localhost:3000/login";
